<template>
  <VAppLayout>
    <VContainer>
      <div>

        <transition name="slide-up">
          <VMenuDishItemDetails
              :without-waiter="false"
              v-if="activeItemId"
              @close="closeActiveItem"
              :is-visible="isMenuDishItemDetailsVisible"
              :dish-id="activeItemId"
              :dish="activeItem"
          />
          <!--            <div v-if="activeItemId" class="test-modal" id="modal1" title="BootstrapVue">-->
          <!--                <ItemDetails @myEvent="closeActiveItem()" :id="activeItemId" :image="activeItemImage"-->
          <!--                             :name="activeItemName"></ItemDetails>-->
          <!--            </div>-->
        </transition>


        <div class="page page-current">
          <div class="navbar navbar-style-1">
            <div class="navbar-inner justify-content-sb">
              <a
                  @click.prevent="handleRedirectBack"
                  href="#">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z"
                      fill="black"></path>
                </svg>
              </a>
              <!--                    <router-link to="/home" class="link back ripple-inset">-->
              <!--                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--                            <path-->
              <!--                                d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z"-->
              <!--                                fill="black"></path>-->
              <!--                        </svg>-->
              <!--                    </router-link>-->

              <!--                    <div v-if="computedCart && computedCart.length > 0" class="right">-->
              <!--                        &lt;!&ndash;          <div v-if="this.$store.state.carts && this.$store.state.carts.length > 0" class="right">&ndash;&gt;-->
              <!--                        <router-link :to="{ name: 'bill', params: { tab: 'bill' }}" class="link panel-open"-->
              <!--                                     data-panel="left">-->
              <!--                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"-->
              <!--                                 xmlns="http://www.w3.org/2000/svg">-->
              <!--                                <path-->
              <!--                                    d="M21.733 21.68C21.8274 21.5791 21.8999 21.4598 21.9458 21.3295C21.9918 21.1992 22.0102 21.0608 22 20.923L21 7.923C20.9806 7.67135 20.8667 7.43636 20.6813 7.26517C20.4958 7.09397 20.2524 6.99925 20 7H17C17 5.67392 16.4733 4.40215 15.5356 3.46447C14.5979 2.52678 13.3261 2 12 2C10.674 2 9.40219 2.52678 8.46451 3.46447C7.52682 4.40215 7.00004 5.67392 7.00004 7H4.00004C3.74764 6.99925 3.50429 7.09397 3.31882 7.26517C3.13335 7.43636 3.01947 7.67135 3.00004 7.923L2.00004 20.923C1.98941 21.0607 2.0074 21.199 2.05287 21.3294C2.09834 21.4597 2.17031 21.5793 2.26425 21.6804C2.35819 21.7816 2.47206 21.8622 2.5987 21.9172C2.72533 21.9722 2.86198 22.0004 3.00004 22H21C21.1377 22 21.2738 21.9715 21.3999 21.9165C21.5261 21.8614 21.6395 21.7809 21.733 21.68ZM12 4C12.7957 4 13.5588 4.31607 14.1214 4.87868C14.684 5.44129 15 6.20435 15 7H9.00004C9.00004 6.20435 9.31611 5.44129 9.87872 4.87868C10.4413 4.31607 11.2044 4 12 4ZM4.08004 20L4.92604 9H7.00004V11C7.00004 11.2652 7.1054 11.5196 7.29293 11.7071C7.48047 11.8946 7.73482 12 8.00004 12C8.26526 12 8.51961 11.8946 8.70715 11.7071C8.89468 11.5196 9.00004 11.2652 9.00004 11V9H15V11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4805 11.8946 15.7348 12 16 12C16.2653 12 16.5196 11.8946 16.7071 11.7071C16.8947 11.5196 17 11.2652 17 11V9H19.074L19.92 20H4.08004Z"-->
              <!--                                    fill="#4A3749"></path>-->
              <!--                            </svg>-->
              <!--                            &lt;!&ndash;              <p class="badge">{{this.$store.state.carts.length}}</p>&ndash;&gt;-->
              <!--                            <p class="badge">{{ computedCart.length }}</p>-->
              <!--                        </router-link>-->

              <!--                    </div>-->


            </div>
          </div>

          <!-- Page Content -->
          <div class="page-content content-area pt-70">

            <!-- Search backdrop -->
            <div class="searchbar-backdrop"></div>

            <div class="container">

              <!-- Search -->
              <div class="filter-bx">
                <form data-search-container=".search-list" data-search-in=".item-title"
                      class="searchbar searchbar-init search-box list-search-bx">
                  <div class="searchbar-inner">
                    <div class="searchbar-input-wrap">
                      <input type="search" :placeholder="$t('Search here...')" v-model="searchText"
                             v-on:input="searchInputChanged">
                      <i class="searchbar-icon">
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M22.707 21.293L17.6 16.182C19.1017 14.3173 19.8314 11.9479 19.6388 9.56147C19.4462 7.17505 18.3459 4.9533 16.5645 3.35365C14.7832 1.754 12.4563 0.898212 10.063 0.962481C7.66967 1.02675 5.39207 2.00618 3.69913 3.69913C2.00618 5.39207 1.02675 7.66967 0.962481 10.063C0.898212 12.4563 1.754 14.7832 3.35365 16.5645C4.9533 18.3459 7.17505 19.4462 9.56147 19.6388C11.9479 19.8314 14.3173 19.1017 16.182 17.6L21.293 22.711C21.4816 22.8931 21.7342 22.9939 21.9964 22.9917C22.2586 22.9894 22.5094 22.8842 22.6948 22.6988C22.8802 22.5134 22.9854 22.2626 22.9877 22.0004C22.9899 21.7382 22.8891 21.4856 22.707 21.297V21.293ZM2.99999 10.333C2.99999 8.88242 3.43015 7.46442 4.23606 6.25833C5.04197 5.05224 6.18745 4.11222 7.52762 3.55716C8.86779 3.0021 10.3425 2.85692 11.7651 3.13998C13.1878 3.42305 14.4946 4.12164 15.5203 5.14742C16.5459 6.1732 17.2443 7.48009 17.5272 8.90281C17.8101 10.3255 17.6647 11.8002 17.1094 13.1403C16.5542 14.4804 15.614 15.6257 14.4078 16.4315C13.2016 17.2372 11.7836 17.6672 10.333 17.667C8.38871 17.6646 6.52477 16.8911 5.15005 15.5162C3.77534 14.1413 3.00211 12.2773 2.99999 10.333Z"
                              fill="#BFBFBF"></path>
                        </svg>
                      </i>
                    </div>
                  </div>
                </form>
              </div>
            </div>


            <!--                                <div class="container">-->
            <!--                                    <div class="tabs-handler" v-if="showCategories">-->
            <!--                                        <scroll-tab ref="scrollTab">-->
            <!--                                            <tab-item-->
            <!--                                                v-for="(item, index) in categories"-->
            <!--                                                :key="index"-->
            <!--                                                :index="index"-->
            <!--                                                class="tab-name"-->
            <!--                                                v-bind:class="{ active: categoryId === item.id}"-->
            <!--                                            ><span @click="changeCategory(item.id, item.description)">{{ item.name }}</span></tab-item>-->
            <!--                                        </scroll-tab>-->
            <!--                                    </div>-->
            <!--                                </div>-->

            <div class="categories_list">
              <Swiper
                  class="tabs-handler"
                  v-if="showCategories"
                  :slides-per-view="'auto'"
                  :space-between="10"
                  direction="horizontal">
                <SwiperSlide
                    v-for="category in categories"
                    :key="category.id"
                    :class="{ active: categoryId === category.id}"
                >
                        <span
                            class="category_item"
                            @click="changeCategory(category.id, category.description)"
                        >
                            {{ category.name }}
                        </span>
                </SwiperSlide>
              </Swiper>
            </div>

            <!-- Products -->
            <VContainer>
              <div class="products">
                <!--                    <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"-->
                <!--                         class="swiper-container swiper-init tabbar tab-style-2 swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">-->
                <!--                        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>-->
                <!--                    </div>-->

                <ul class="subcategories_list">
                  <li
                      v-for="(subcategory, i) in subcategories" :key="i"
                      v-bind:class="{ active_subcategory: subcategory.id === subcategoryId }"
                  >
                                <span @click="changeSubcategory(subcategory.id)">
                                    {{ subcategory.name }}
                                </span>
                  </li>
                </ul>

                <p v-if="categoryDescription" class="category-description" v-html="categoryDescription">
                </p>

                <div v-if="loading" id="loading-handler">
                  <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>

                <div v-if="!loading && (items && items.length === 0)" class="text-center">
                  <h1 style="font-size: 50px">🔎</h1>
                  <p style="font-size: 18px">{{ $t("No items found") }}...</p>
                </div>

                <transition name="fade">
                  <ul
                      v-if="!loading"
                      class="catalog_list">
                    <li
                        v-for="item in items"
                        :key="item.id"
                        class="catalog_list__item"
                    >
                      <div class="catalog_list__item_image"
                           @click="setActiveItem(item)">
                        <img
                            v-if="!!item.image"
                            :src="item.image"
                            alt="">
                        <img
                            v-else
                            src="@/assets/img/menus/pic1.jpg"
                            alt="">
                      </div>
                      <div class="catalog_list__item_info">
                        <h6
                            @click="setActiveItem(item)"
                        >{{ item.name }}</h6>
                        <div class="catalog_list__item_info-price">
                          <ul>
                            <li class="price">
                              <svg width="16" height="16" viewBox="0 0 16 16"
                                   fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.98806 15.7658C8.30048 16.0781 8.80688 16.0781 9.11926 15.7658L15.7657 9.1201C16.078 8.80768 16.078 8.30128 15.7657 7.98889L8.01208 0.234418C7.86207 0.0843767 7.65863 6.93032e-05 7.44646 0H0.800002C0.358159 0 0 0.358159 0 0.800002V7.44646C3.46516e-05 7.65863 0.0843767 7.86207 0.234418 8.01208L7.98806 15.7658ZM1.6 1.6H7.11526L14.0689 8.55368L8.55368 14.0689L1.6 7.11526V1.6Z"
                                    fill="#4A3749"></path>
                                <path
                                    d="M4.12324 4.12324C3.5115 4.73494 3.5115 5.72674 4.1232 6.33848C4.73491 6.95022 5.72671 6.95022 6.33845 6.33851C6.95019 5.72681 6.95019 4.73501 6.33848 4.12327C6.33848 4.12327 6.33848 4.12327 6.33845 4.12324C5.72733 3.51153 4.73605 3.51101 4.12435 4.12213C4.124 4.12251 4.12362 4.12289 4.12324 4.12324Z"
                                    fill="#4A3749"></path>
                              </svg>
                              {{ formatPrice(item.price) }}
                            </li>
                            <i v-if="item.is_vegetarian" class="iconmoon-vegeterian"
                               @click="showIconDetails('vegeterian')"></i>
                            <i v-if="item.is_gluten_free"
                               class="iconmoon-gluten-free"
                               @click="showIconDetails('gluten-free')"></i>
                            <i v-if="item.is_spicy" class="iconmoon-chili-pepper"
                               @click="showIconDetails('chili-pepper')"></i>
                            <i v-if="item.is_low_calorie"
                               class="iconmoon-low-calories"
                               @click="showIconDetails('low-calories')"></i>
                            <li class="counter" v-if="orderIsAvailable()">
                              <VItemCounter
                                  :value="getItemCount['item' + item.id] ? getItemCount['item' + item.id] : 1"
                                  :id="item.id"
                                  @update:value="value => updateItemCount(item, value)"
                              />
                              <div class="add-to-order" @click="addToCart(item)">
                                <VButton type="violet">
                                  {{ getAddToCartButtonText() }}
                                </VButton>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </transition>


                <!--                    <div-->
                <!--                        class="tabs-swipeable-wrap mt-20 tabs-height-auto swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">-->
                <!--                        <div class="tabs swiper-wrapper" id="swiper-wrapper-9f292ffc6fb810ff10" aria-live="polite"-->
                <!--                             style="transform: translate3d(0px, 0px, 0px);">-->
                <!--                            <div id="tab-1" class="tab tab-active swiper-slide swiper-slide-active" role="group"-->
                <!--                                 aria-label="1 / 3">-->
                <!--                                <div class="list search-list mt-0 mb-20 searchbar-found item-list">-->

                <!--                                    <ul v-if="showCategories" id="subcategories-handler">-->
                <!--                                        <li v-for="(subcategory, i) in subcategories" :key="i"-->
                <!--                                            v-bind:class="{ activeSubcategory: subcategory.id === subcategoryId }"-->
                <!--                                            class="col-50 medium-25 vertical-li">-->
                <!--                      <span @click="changeSubcategory(subcategory.id)">-->
                <!--                        {{ subcategory.name }}-->
                <!--                      </span>-->
                <!--                                        </li>-->
                <!--                                    </ul>-->

                <!--                                    <p v-if="categoryDescription" class="category-description">-->
                <!--                                        {{ categoryDescription }}-->
                <!--                                    </p>-->
                <!--                                    <div v-if="loading" id="loading-handler">-->
                <!--                                        <div class="lds-ring">-->
                <!--                                            <div></div>-->
                <!--                                            <div></div>-->
                <!--                                            <div></div>-->
                <!--                                            <div></div>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                    <div v-if="!loading && (items && items.length === 0)" class="text-center">-->
                <!--                                        <h1 style="font-size: 50px">🔎</h1>-->
                <!--                                        <p style="font-size: 18px">{{ $t("No items found") }}...</p>-->
                <!--                                    </div>-->
                <!--                                    <transition name="fade">-->
                <!--                                        <ul class="row left-items" v-if="!loading">-->

                <!--                                            <li v-for="item in items" :key="item.id" class="col-50 medium-25">-->
                <!--                                                <div class="item-bx item-grid">-->
                <!--                                                    <div class="dz-media item-bx-graphics"-->
                <!--                                                         :style="{'background-image': 'url(' + require('@/assets/img/menus/pic1.jpg') + ')'}">-->
                <!--                            <span @click="setActiveItem(item)">-->
                <!--                              <div v-if="item.image" class="dish-image" style="background-color: white;"-->
                <!--                                   v-bind:style="{ backgroundImage: 'url(' + item.image + ')' }"></div>-->
                <!--                              <img v-if="!item.image" src="@/assets/img/menus/pic1.jpg" alt="">-->
                <!--                            </span>-->
                <!--                                                        &lt;!&ndash;                            <span @click="setActiveItem(item)" class="cart-btn">&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                                <path d="M21.733 21.68C21.8274 21.5791 21.8999 21.4598 21.9458 21.3295C21.9918 21.1992 22.0102 21.0608 22 20.923L21 7.923C20.9806 7.67135 20.8667 7.43636 20.6813 7.26517C20.4958 7.09397 20.2524 6.99925 20 7H17C17 5.67392 16.4733 4.40215 15.5356 3.46447C14.5979 2.52678 13.3261 2 12 2C10.674 2 9.40219 2.52678 8.46451 3.46447C7.52682 4.40215 7.00004 5.67392 7.00004 7H4.00004C3.74764 6.99925 3.50429 7.09397 3.31882 7.26517C3.13335 7.43636 3.01947 7.67135 3.00004 7.923L2.00004 20.923C1.98941 21.0607 2.0074 21.199 2.05287 21.3294C2.09834 21.4597 2.17031 21.5793 2.26425 21.6804C2.35819 21.7816 2.47206 21.8622 2.5987 21.9172C2.72533 21.9722 2.86198 22.0004 3.00004 22H21C21.1377 22 21.2738 21.9715 21.3999 21.9165C21.5261 21.8614 21.6395 21.7809 21.733 21.68ZM12 4C12.7957 4 13.5588 4.31607 14.1214 4.87868C14.684 5.44129 15 6.20435 15 7H9.00004C9.00004 6.20435 9.31611 5.44129 9.87872 4.87868C10.4413 4.31607 11.2044 4 12 4ZM4.08004 20L4.92604 9H7.00004V11C7.00004 11.2652 7.1054 11.5196 7.29293 11.7071C7.48047 11.8946 7.73482 12 8.00004 12C8.26526 12 8.51961 11.8946 8.70715 11.7071C8.89468 11.5196 9.00004 11.2652 9.00004 11V9H15V11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4805 11.8946 15.7348 12 16 12C16.2653 12 16.5196 11.8946 16.7071 11.7071C16.8947 11.5196 17 11.2652 17 11V9H19.074L19.92 20H4.08004Z" fill="#4A3749"></path>&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                              </svg>&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                            </span>&ndash;&gt;-->
                <!--                                                    </div>-->
                <!--                                                    <div class="dz-info" @click="setActiveItem(item)">-->
                <!--                                                        <div class="dz-head">-->
                <!--                                                            <h6 class="item-title">{{ item.name }}</h6>-->
                <!--                                                        </div>-->
                <!--                                                        &lt;!&ndash;                            <ul class="tag-list">&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                              <li><a href="/item-details/">Coffee</a></li>&ndash;&gt;-->
                <!--                                                        &lt;!&ndash;                            </ul>&ndash;&gt;-->
                <!--                                                        <div class="dz-meta">-->
                <!--                                                            <ul>-->
                <!--                                                                <li class="price">-->
                <!--                                                                    <svg width="16" height="16" viewBox="0 0 16 16"-->
                <!--                                                                         fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                                                                        <path-->
                <!--                                                                            d="M7.98806 15.7658C8.30048 16.0781 8.80688 16.0781 9.11926 15.7658L15.7657 9.1201C16.078 8.80768 16.078 8.30128 15.7657 7.98889L8.01208 0.234418C7.86207 0.0843767 7.65863 6.93032e-05 7.44646 0H0.800002C0.358159 0 0 0.358159 0 0.800002V7.44646C3.46516e-05 7.65863 0.0843767 7.86207 0.234418 8.01208L7.98806 15.7658ZM1.6 1.6H7.11526L14.0689 8.55368L8.55368 14.0689L1.6 7.11526V1.6Z"-->
                <!--                                                                            fill="#4A3749"></path>-->
                <!--                                                                        <path-->
                <!--                                                                            d="M4.12324 4.12324C3.5115 4.73494 3.5115 5.72674 4.1232 6.33848C4.73491 6.95022 5.72671 6.95022 6.33845 6.33851C6.95019 5.72681 6.95019 4.73501 6.33848 4.12327C6.33848 4.12327 6.33848 4.12327 6.33845 4.12324C5.72733 3.51153 4.73605 3.51101 4.12435 4.12213C4.124 4.12251 4.12362 4.12289 4.12324 4.12324Z"-->
                <!--                                                                            fill="#4A3749"></path>-->
                <!--                                                                    </svg>-->
                <!--                                                                    {{ item.price }} zł-->
                <!--                                                                </li>-->
                <!--                                                                <i v-if="item.is_vegetarian" class="iconmoon-vegeterian"-->
                <!--                                                                   @click="showIconDetails('vegeterian')"></i>-->
                <!--                                                                <i v-if="item.is_gluten_free"-->
                <!--                                                                   class="iconmoon-gluten-free"-->
                <!--                                                                   @click="showIconDetails('gluten-free')"></i>-->
                <!--                                                                <i v-if="item.is_spicy" class="iconmoon-chili-pepper"-->
                <!--                                                                   @click="showIconDetails('chili-pepper')"></i>-->
                <!--                                                                <i v-if="item.is_low_calorie"-->
                <!--                                                                   class="iconmoon-low-calories"-->
                <!--                                                                   @click="showIconDetails('low-calories')"></i>-->
                <!--                                                            </ul>-->
                <!--                                                        </div>-->
                <!--                                                    </div>-->
                <!--                                                </div>-->
                <!--                                            </li>-->
                <!--                                        </ul>-->
                <!--                                    </transition>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>-->
                <!--                    </div>-->
              </div>
              <!--                  <VNav/>-->
            </VContainer>

          </div>

          <vue-bottom-sheet
              ref="iconDetails"
              @opened="false"
              @closed="false"
              max-height="90%"
          >
            <div class="padding-30">
              <div v-if="activeIcon">
                <div class="text-align-center">
                  <i v-if="activeIcon.icon === 'iconmoon-vegeterian'" class="iconmoon-vegeterian font-40"></i>
                  <i v-if="activeIcon.icon === 'iconmoon-gluten-free'"
                     class="iconmoon-gluten-free font-40"></i>
                  <i v-if="activeIcon.icon === 'iconmoon-chili-pepper'"
                     class="iconmoon-chili-pepper font-40"></i>
                  <i v-if="activeIcon.icon === 'iconmoon-low-calories'"
                     class="iconmoon-low-calories font-40"></i>
                  <h2>{{ $t(activeIcon.name) }}</h2>
                  <p>{{ $t(activeIcon.description) }}</p>
                </div>

              </div>
              <div style="height:400px"></div>
            </div>
          </vue-bottom-sheet>
        </div>
      </div>
    </VContainer>
  </VAppLayout>
</template>

<script>

import axios from "axios";
import router from "../router/router";
import {BASE_API_URL} from "@/appConstants";
import i18n from "../i18n";
import vueBottomSheet from "@webzlodimir/vue-bottom-sheet";
// import {scrollTab, tabItem} from "vue-scrollable-tabs";
// import ItemDetails from "./ItemDetails";
import {Swiper, SwiperSlide} from "swiper-vue2";
import VContainer from "@/components/ui/VContainer.vue";
import VMenuDishItemDetails from "@/modules/menu/components/VMenuDishItemDetails.vue";
import VItemCounter from "@/components/ui/VItemCounter.vue";
import VAppLayout from "@/layouts/VAppLayout.vue";
import VButton from "@/components/ui/VButton.vue";
// import VNav from "@/components/VNav.vue";

export default {
  name: "FullMenu",
  components: {
    VButton,
    VAppLayout,
    VItemCounter,
    VMenuDishItemDetails,
    VContainer,
    // scrollTab,
    // tabItem,
    // ItemDetails,
    vueBottomSheet,
    Swiper,
    SwiperSlide,
    // VNav
  },
  data() {
    return {
      isMenuDishItemDetailsVisible: false,
      categoryId: this.$route.params.id,
      fullMenuItems: [],
      items: [],
      subcategories: [],
      subcategoryId: 0,
      loading: false,
      searchText: '',
      categories: [],
      showCategories: true,
      activeItemId: null,
      activeItem: null,
      activeItemImage: null,
      activeItemName: null,
      activeIcon: null,
      itemCount: {},
      iconsOptions: {
        "vegeterian": {
          "name": "vegeterian",
          "description": "vegeterian-description",
          "icon": "iconmoon-vegeterian"
        },
        "gluten-free": {
          "name": "gluten-free",
          "description": "gluten-free-description",
          "icon": "iconmoon-gluten-free"
        },
        "chili-pepper": {
          "name": "chili-pepper",
          "description": "chili-pepper-description",
          "icon": "iconmoon-chili-pepper"
        },
        "low-calories": {
          "name": "low-calories",
          "description": "low-calories-description",
          "icon": "iconmoon-low-calories"
        },
      },
      categoryDescription: null,
      toastOptions: {
        position: "top-center",
        timeout: 2000,
        closeOnClick: true
      }
    }
  },
  created() {
    this.categories = this.$store.state.companyData.menu;

    if (this.$route.params.id) {
      this.getItems(this.$route.params.id)
      this.categoryDescription = this.$store.state.companyData.menu.find(x => x.id === this.$route.params.id).description;
    } else {
      this.categoryId = this.$store.state.companyData.menu[0].id;
      this.categoryDescription = this.$store.state.companyData.menu[0].description;
      this.getItems(this.$store.state.companyData.menu[0].id)
    }

    this.getFullMenuItems();
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    },
    handleRedirectBack: function () {
      this.$router.go(-1)
    },
    getItems(categoryId) {
      this.loading = true;

      const endpoint = BASE_API_URL +
          'categoryitems?token=' + this.$store.state.companyData.token +
          '&category=' + categoryId +
          '&pref_lang_code=' + this.$store.state.prefLangCode +
          '&legacy=0'

      axios.get(endpoint).then(
          response => {
            this.items = response.data.items;
            this.subcategories = response.data.subcategories;
            this.loading = false;
          }
      ).catch(error => {
        this.loading = false;
        router.push('error');
        console.log(error);
      })
    },
    getSubcategoryItems(categoryId) {
      this.loading = true;
      this.subcategoryId = categoryId;

      const endpoint = BASE_API_URL +
          'categoryitems?token=' + this.$store.state.companyData.token +
          '&category=' + categoryId +
          '&pref_lang_code=' + this.$store.state.prefLangCode +
          '&legacy=0';

      axios.get(endpoint).then(
          response => {
            this.items = response.data.items;
            this.loading = false;
          }
      ).catch(error => {
        this.loading = false;
        router.push('error');
        console.log(error);
      })
    },
    changeCategory(category, categoryDescription) {
      this.categoryDescription = categoryDescription;
      this.categoryId = category;
      this.subcategoryId = 0;
      this.getItems(category)
    },
    changeSubcategory(subcategory) {
      this.getSubcategoryItems(subcategory)
    },
    getFullMenuItems() {
      const endpoint = BASE_API_URL +
          'allitems?token=' + this.$store.state.companyData.token +
          '&pref_lang_code=' + i18n.locale;

      axios.get(endpoint).then(
          response => {
            this.fullMenuItems = response.data.items;
            this.fullMenuItems.forEach(item => {
              var item_id = 'item' + item.id;
              this.itemCount[item_id] = 1
            })
            // console.log(this.fullMenuItems);
          }
      ).catch(error => {
        this.loading = false;
        router.push('error');
        console.log(error);
      })
    },
    searchInputChanged() {
      if (this.searchText.length > 0) {
        this.showCategories = false;
        let val = this.searchText;
        if (val && val.trim() !== '') {
          let prod = [];
          this.items = this.fullMenuItems.filter(function (item) {
            if (item.name.toLowerCase().includes(val.toLowerCase())) {
              prod.push(item);
            }
            return prod;
          });
          this.items = prod;
        }
      } else {
        this.showCategories = true;
        this.categoryId = this.$store.state.companyData.menu[0].id;
        this.getItems(this.$store.state.companyData.menu[0].id)
      }
    },
    setActiveItem(item) {
      this.isMenuDishItemDetailsVisible = true;
      this.activeItemImage = item.image;
      this.activeItemName = item.name;
      this.activeItemId = item.id;
      this.activeItem = item;
    },
    closeActiveItem() {
      this.isMenuDishItemDetailsVisible = false
      this.activeItemImage = null;
      this.activeItemName = null;
      this.activeItemId = null;
      this.activeItem = null;
    },
    showIconDetails(icon) {
      this.activeIcon = this.iconsOptions[icon];
      this.$refs.iconDetails.open();
    },
    orderIsAvailable() {
      var locale = this.$store.getters['getCompanyData'].locale;
      // var tableData = this.$store.getters['getTableData'];
      // var table = tableData ? tableData.id : false;

      return locale.activePaymentCredentials
          && locale.pos_terminal_enabled
          // && locale.posConnection
          && (this.$store.getters['getCartEnabled'])
      // && table;
    },
    updateItemCount: function (item, value) {
      var item_id = 'item' + item.id;
      this.itemCount[item_id] = value
      this.itemCount.__ob__.dep.notify()
      return this.itemCount[item.id];
    },
    addToCart(computedDish) {
      var count = this.itemCount['item' + computedDish.id];
      count = count ? count : 1;

      let item = {
        ...computedDish, count: count, product: computedDish
      }

      if(this.$store.getters['getIsModeWMM']) {
        this.$store.dispatch('cartStore/SET_ITEM_TO_CART', item).then(resp => {
          if (resp) {
            this.$toast.success(this.$t('Added to cart'), this.toastOptions);
            this.$emit('close')
          }
        })
      } else {
        // this.$store.commit('addToCart', item);
        this.$store.commit('cartStore/ADD_TO_CART', item);
        this.$toast.success(this.$t('Added to cart'), this.toastOptions);
        this.$emit('close')
      }

      console.log(item)


    },
    getAddToCartButtonText() {
      var text = this.$t('pages.menu.makeOrder');
      if(this.$store.getters['getIsModeSOT'] || this.$store.getters['getIsModeQSR']) {
        text = this.$t('Add to cart');
      }
      return text;
    }
  },
  computed: {
    computedCart: function () {
      return this.$store.getters['cartStore/getCart']
    },
    getItemCount: function () {
      return this.itemCount;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.categories_list {
  padding: 0 32px;

  .swiper-slide {
    width: fit-content;
    font-size: 18px;
    letter-spacing: unset;
    text-transform: capitalize;
    padding-right: 25px;
    cursor: pointer;
  }

  .swiper-slide.active {
    color: #4e3b4d;
  }

}

.products {
  .subcategories_list {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow-x: scroll;

    //styles to hidde scrollbar start
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    //styles to hidde scrollbar end

    & > li {
      flex-shrink: 0;
      width: fit-content;
      padding: 5px 13px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
    }

    .active_subcategory {
      border-color: #a4a4a4;
      background-color: #fff4f4;
    }
  }
}

.catalog_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 70px;

  &__item {
    display: flex;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 10px 0 #0000001A;

    &:last-of-type {
      margin-bottom: 20px;
    }

    &_image {
      flex-shrink: 0;
      width: 111px;
      height: 120px;
      overflow: hidden;

      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &_info {
      flex: 1;
      padding: 16px 16px 16px 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 5px;

      h6 {
        margin: 0;
        padding: 0;
        font: {
          size: 16px;
          weight: 700;
        }
        height: 45px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        line-height: 20px;
        max-width: 1000px;
        overflow: hidden;
        width: 100%;
      }

      &-price {
        //margin-left: auto;
        display: flex;
        align-items: center;

        .add-to-order {
          .btn {
            height: auto;
            padding: 10px 16px;
            font-size: 14px;
            gap: 10px;
          }
        }

        & > ul {
          display: block;
          align-items: center;
          flex-direction: row-reverse;
          gap: 10px;
          width: 100%;

          i {
            float: right;
            margin-left: 5px;
          }

          li {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            font: {
              size: 16px;
              weight: 700;
            };
            color: $color_black;

            &.counter {
              display: flex;
              width: 100%;
              justify-content: space-between;
            }
          }
        }
      }
    }

  }
}

//#subcategories-handler {
//    margin-top: 20px;
//}

.item-bx-graphics {
  height: 185px;
  overflow: hidden;
}

.dish-image {
  border-radius: 22px;
  height: 185px;
  overflow: hidden;
  display: flex;
  background-size: cover;
}

.tab-name {
  font-size: 18px;
  letter-spacing: unset;
  text-transform: capitalize;
  padding-right: 25px;
  cursor: pointer;
}

.tab-name.active {
  color: #4e3b4d;
}

.tab-name.active span {
  font-size: 18px;
  letter-spacing: unset;
  text-transform: capitalize;
}

.tab-name.active span:after {
  content: "\f111";
  font-size: 15px;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  opacity: 1;
  color: #FFCFA7;
  transition: all 0.5s;
  margin-left: 5px;
}

.page-content .searchbar.search-box .searchbar-input-wrap .searchbar-icon {
  position: absolute;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0
}

.slide-up-enter-active {
  transition: all .4s ease;
}

.slide-up-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-up-enter, .slide-fade-leave-to {
  transform: translateY(100vh);
  opacity: 0;
}

.test-modal {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
  background-color: white;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #4e3b4d;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #4e3b4d transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

#loading-handler {
  text-align: center;
  margin-top: 50px;
}

.text-center {
  text-align: center;
}

//.vertical-li.activeSubcategory {
//    /*font-weight: bold;*/
//    border: 1px solid #a4a4a4;
//    background-color: #fff4f4;
//}

.vertical-li {
  cursor: pointer;
  display: inline-block;
  padding: 7px 14px;
  border: 1px solid #f0f0f0;
  border-radius: 15px;
  margin-right: 5px;
}

//#subcategories-handler {
//    margin-bottom: 15px;
//    width: 100%;
//    overflow: auto;
//    white-space: nowrap;
//}

.item-bx-graphics {
  border-radius: 22px;
  background-position: center;
}

.row.left-items {
  justify-content: left;
}

.row.left-items li {
  margin: 5px;
}

@media (max-width: 7680px) {
  .row.left-items {
    justify-content: space-between;
  }

  .row.left-items li {
    margin: 0;
  }
}

.justify-content-sb {
  justify-content: space-between;
}

.badge {
  padding: 0;
  background-color: #c04222;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  font-size: 8px;
  margin-left: -10px;
  margin-top: -10px;
  z-index: 1;
}

.navbar.navbar-style-1 .right .link {
  width: 60px
}

.category-description {
  white-space: pre-line;
}

</style>
